export default function LessonHeader({
  lesson,
}: {
  lesson: {
    id: number;
    title: string;
    subject: string;
    topic: string;
  };
}) {
  return (
    <div className="flex items-start gap-4 mb-8">
      <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center shrink-0">
        <svg
          className="w-6 h-6 text-white"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
        </svg>
      </div>
      <div>
        <h2 className="text-xl font-bold text-foreground mb-1">
          {lesson.title}
        </h2>
        <p className="text-muted-foreground text-sm">
          {lesson.subject} • {lesson.topic}
        </p>
      </div>
    </div>
  );
}
